import { EmptyState, FlexColumn, Loading } from '@gorila-shared-ui/components';
import { useEffect } from 'react';
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import { getStreamingMediaByGroup } from '../../../services/reportsService';
import { apiParamsState, isAllWorkspacesSelect } from '../../../storage/app';
import {
  evidenceAlarmFilterState,
  evidenceMediaTypeFilterState,
  evidenceOriginFilterState,
  loadingEvidenceState,
  reportEndDateState,
  reportEvidenceState,
  reportEvidenceStates,
  reportFilterGroupState,
  reportStartDateState,
} from '../../../storage/reports';
import { EvidenceMedia } from '../../../types/evidences';
import { StreamingMediaLibrary } from './StreamingMediaLibrary';

function StreamingMediaReportByGroup() {
  const { css } = useStyles();
  const apiParams = useRecoilValue(apiParamsState);
  const isAllWorkspacesSelected = useRecoilValue(isAllWorkspacesSelect);
  const [isloadingEvidenceState, setIsLoadingEvidenceState] = useRecoilState(loadingEvidenceState);
  const groupId = useRecoilValue(reportFilterGroupState);
  const endDate = useRecoilValue(reportEndDateState);
  const startDate = useRecoilValue(reportStartDateState);
  const mediaType = useRecoilValue(evidenceMediaTypeFilterState);
  const origin = useRecoilValue(evidenceOriginFilterState);
  const alarmType = useRecoilValue(evidenceAlarmFilterState);
  const setReportHistorics = useSetRecoilState(reportEvidenceStates);
  const resetReportHistorics = useResetRecoilState(reportEvidenceStates);
  const states = useRecoilValue(reportEvidenceState(groupId));

  useEffect(() => {
    return () => {
      resetReportHistorics();
    };
  }, []);

  useEffect(() => {
    loadLibrary();
  }, [apiParams?.clientId, apiParams?.subClientId, groupId, startDate, endDate, mediaType, origin, alarmType]);

  const loadLibrary = async () => {
    if (!groupId || !startDate || !endDate || !apiParams) return;

    const loadHistoricEvidence = async () => {
      setIsLoadingEvidenceState(true);
      const { data, error } = await getStreamingMediaByGroup(
        apiParams.clientId,
        groupId,
        startDate,
        endDate,
        isAllWorkspacesSelected ? undefined : apiParams.subClientId,
        mediaType,
        origin,
        alarmType,
      );
      const newHistorics: { [key: string]: EvidenceMedia[] } = {};
      if (!error) {
        newHistorics[groupId] = data ?? [];
      }
      setReportHistorics(newHistorics);
      setIsLoadingEvidenceState(false);
    };

    loadHistoricEvidence();
  };

  if (isloadingEvidenceState) {
    return <Loading />;
  }

  if (!groupId) {
    return <EmptyState title="Selecciona un grupo para visualizar el reporte." />;
  }

  return (
    <FlexColumn
      gap={0}
      classNames={css({ flex: 1, overflow: 'hidden' })}
    >
      <StreamingMediaLibrary
        states={states}
        extended
      />
    </FlexColumn>
  );
}

export default StreamingMediaReportByGroup;
